import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Markdown link regex: [text](url)
const MD_LINK_RE = /\[([^\]]*)\]\(([^)]+)\)/g;

/** Clean escaped slashes from URLs (Todoist returns \/ instead of /) */
export function cleanUrl(url: string): string {
  return url.replace(/\\\//g, "/");
}

/**
 * Strip markdown links from task content for plain text contexts (e.g. AI context messages).
 * "[Open in Spark](spark://...)" → "Open in Spark"
 */
export function stripTaskLinks(content: string): string {
  return content.replace(MD_LINK_RE, "$1");
}

/**
 * Replace markdown links in task content with HTML <a> tags showing "Link".
 * For use in email HTML builders.
 */
export function taskContentToHtml(content: string): string {
  return content.replace(MD_LINK_RE, (_, _text, url) =>
    `<a href="${cleanUrl(url)}" style="color: #E8850C;">Link</a>`
  );
}
